import DialogTitle from './DialogTitle'
import EditableDialogTitle from './EditableDialogTitle'
export { EditableDialogTitle }
export default DialogTitle
